import './styles.scss';

import React from 'react';

import {AlertTypeDTO} from 'kashable-mobile-common';

interface NotificationBannerProps {
    notification: AlertTypeDTO;
}

export const NotificationBanner = ({notification}: NotificationBannerProps) => {
    return (
        <div className='notification-banner dashboard-banner'>
            <div className='notification-banner__wrap'>
                <div className='notification-banner__description'>
                    <div 
                        dangerouslySetInnerHTML={{ __html: notification.message || '' }}
                    />
                </div>
            </div>
        </div>
    );
};
